// extracted by mini-css-extract-plugin
export default {"container":"style_container__zP6Si","page":"style_page__mefIo","error":"style_error__6PLdh"};